module.exports = __webpack_public_path__ + "static/media/galerija_2022_0034.52b1f3c4.jpg";